import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

// Compatibility patch for browser translation extensions (Google Translate, etc.).
// Translation extensions wrap text nodes in <font> tags; React's reconciler then sees
// a parent mismatch when it tries to remove or replace those nodes during re-render
// and throws (Failed to execute 'removeChild' / 'insertBefore' on 'Node'), which the
// app's error boundary catches and shows a "Something went wrong" screen on transitions
// like navigating away from the test screen. Making both DOM ops tolerant of mismatched
// parents (no-op instead of throw) is the standard mitigation; runs before React mounts.
// See https://github.com/facebook/react/issues/11538.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer position="top-right" style={{ zIndex: 10000 }} />
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
